export default "__VITE_ASSET__CBRRUco7__"